/*
 * The blank Lienzo: the mockup's `.editor` with no mockup open. The conversation column
 * (`.conv`, 440px here as in the mockup's blank state) holds the creation hero; the preview side
 * (`.pv`) is the dotted canvas with the "your screen will appear here" state.
 */
.srOnly {
  position: absolute;
  inline-size: 1px;
  block-size: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}

.editor {
  display: flex;
  flex: 1;
  min-block-size: 0;
}

.conversation {
  display: flex;
  flex: none;
  flex-direction: column;
  inline-size: 440px;
  min-block-size: 0;
  background: var(--surface-raised);
}

.head {
  display: flex;
  flex: none;
  align-items: center;
  gap: var(--space-2);
  block-size: 40px;
  padding: 0 var(--space-4);
  border-bottom: 1px solid var(--border);
}

.headTitle {
  margin: 0;
  font-size: var(--font-size-13);
  font-weight: var(--font-weight-semibold);
}

.meta {
  color: var(--text-subtle);
  font-size: var(--font-size-12);
}

.thread {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: var(--space-4);
  padding: var(--space-4);
  overflow-y: auto;
}

.hero {
  margin-block-start: var(--space-2);
}

.heroTitle {
  margin: 0 0 var(--space-4);
  font-size: var(--font-size-20);
  font-weight: var(--font-weight-semibold);
  letter-spacing: -0.01em;
}

.divider {
  position: relative;
  z-index: 2;
  flex: none;
  inline-size: 9px;
  margin: 0 -4px;
}

.divider::before {
  content: "";
  position: absolute;
  inset-block: 0;
  inset-inline-start: 4px;
  inline-size: 1px;
  background: var(--border);
}

.preview {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-inline-size: 0;
  background: var(--canvas);
}

.stage {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  min-block-size: 0;
  padding: var(--space-6);
  overflow: auto;
  background-image: radial-gradient(var(--canvas-dot) 1px, transparent 1px);
  background-size: 16px 16px;
}

/* Below 1024px the columns stack, as in the mockup: the conversation on top. */
@media (max-width: 1023.98px) {
  .editor {
    flex-direction: column;
  }

  .conversation {
    inline-size: 100%;
    border-bottom: 1px solid var(--border);
  }

  .divider {
    display: none;
  }
}
